import BaseLayer from "./BaseLayer";
import {plotTileMotionHelper} from "../utils/map_utils";

class StitchRound0TileMotionv2 extends BaseLayer {

    id = "stitchRound0TileMotionv2";
    label = "Tiles Moved";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchR0TileMotion, textColor} = this.props;
        plotTileMotionHelper(stitchR0TileMotion, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchRound0TileMotionv2;
